<template>
  <div class="detailPage">
    <p class="title">基本信息</p>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">成品编码：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.itemCode"
          >{{labelTemplateDetailData.itemCode}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">产品型号：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.product"
          >{{labelTemplateDetailData.product.name}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">客户：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.customer"
          >{{labelTemplateDetailData.customer.name}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">标签类型：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.labelType"
          >{{labelTemplateDetailData.labelType.title}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">包装规格：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.inQuantity"
          >{{labelTemplateDetailData.inQuantity}} in One</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">打印机：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.printerType"
          >{{labelTemplateDetailData.printerType.title}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li v-if="labelTemplateDetailData.netcFid<=0">
        <div class="left">标签宽(W)：</div>
        <div class="right">
          <span class="value" v-if="labelTemplateDetailData.width">{{labelTemplateDetailData.width}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li v-if="labelTemplateDetailData.netcFid<=0">
        <div class="left">标签高(H)：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.height"
          >{{labelTemplateDetailData.height}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">创建人：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.createUser"
          >{{labelTemplateDetailData.createUser.name}}({{ labelTemplateDetailData.createUser.employeeNum }}) 于 {{labelTemplateDetailData.createDateTime}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最后修改人：</div>
        <div class="right">
          <span
            class="value"
            v-if="labelTemplateDetailData.lastUpdateUser"
          >{{labelTemplateDetailData.lastUpdateUser.name}}({{ labelTemplateDetailData.lastUpdateUser.employeeNum }}) 于 {{labelTemplateDetailData.lastUpdateDateTime}}</span>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
      <li v-if="labelTemplateDetailData.netcFid>0 && labelTemplateDetailData.printerType.code=='NETC'" class="blockLi">
        <div class="left">镭雕模版：</div>
        <div class="right">
          <span :title="labelTemplateDetailData.netcLabelName" class="allowSkip" @click="downloadFile(labelTemplateDetailData.netcFid, '镭雕模版')">{{labelTemplateDetailData.netcLabelName}}</span>
        </div>
      </li>
      <li v-else-if="labelTemplateDetailData.netcFid>0 && labelTemplateDetailData.printerType.code=='BarTender'" class="blockLi">
        <div class="left">标签模版：</div>
        <div class="right">
          <span :title="labelTemplateDetailData.netcLabelName" class="allowSkip" @click="downloadFile(labelTemplateDetailData.netcFid, 'BarTender模版')">{{labelTemplateDetailData.netcLabelName}}</span>
        </div>
      </li>
      <li v-else-if="labelTemplateDetailData.netcFid>0 && labelTemplateDetailData.printerType.code=='CodeSoft'" class="blockLi">
        <div class="left">标签模版：</div>
        <div class="right">
          <span :title="labelTemplateDetailData.netcLabelName" class="allowSkip" @click="downloadFile(labelTemplateDetailData.netcFid, 'CodeSoft模版')">{{labelTemplateDetailData.netcLabelName}}</span>
        </div>
      </li>      
      <li v-else-if="labelTemplateDetailData.netcFid<=0" class="blockLi">
        <div class="left">打印机指令：</div>
        <div class="right">
          <el-input
            v-if="labelTemplateDetailData.commands"
            class="detailTextArea"
            type="textarea"
            :readonly="true"
            :autosize="{minRows: 1}"
            resize="none"
            :value="labelTemplateDetailData.commands"
          ></el-input>
          <span class="noValue" v-else>-</span>
        </div>
      </li>
    </ul>
    <!-- <div class="operationBox">
      <el-button icon="el-icon-refresh-left" size="small" @click="rollbackLabelTemplateBtn">还原</el-button>
    </div> -->
  </div>
</template>

<script>
import {
  apiLabelTemplateDetail,
  apiLabelTemplateRollback
} from "@/api/labelTemplate.js";
import { apiDownloadFile } from "@/api/filesUpload.js";
export default {
  props: {
    printLink: {
      type: String
    }
  },
  components: {},
  data() {
    return {
      labelTemplateDetailData: {}
    };
  },
  methods: {
    downloadFile(fid, fileName, secretKey) {
      let a = document.createElement("a");
      a.download = fileName + "下载";
      a.href = apiDownloadFile(fid, secretKey);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 订单详情数据
    async getLabelTemplateDetail(remove, callback) {
      if (remove != "noRemove") {
        this.labelTemplateDetailData = {};
      }
      const res = await apiLabelTemplateDetail({
        id: this.printLink
      });
      if (res.code == 0) {
        this.labelTemplateDetailData = res.data;
        if(callback) callback();
      }
    },
    // 还原打印指令
    rollbackLabelTemplateBtn() {
      this.$confirm(
        '废除当前打印指令，并将打印指令还原成上一版本？',
        "还原打印指令",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        const res = await apiLabelTemplateRollback({
          id: this.printLink
        });
        // console.log(res);
        if (res.code == 0) {
          this.getLabelTemplateDetail("noRemove");
          this.$message({
            type: "success",
            message: "还原成功"
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>